import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { filterNonUCHAccounts } from "utils/account.util";

import { FormControl, MenuItem, Select } from "@mui/material";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import { EVOKE_ROLES } from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";
import { changeFilter } from "app/store/dashboard/transmission_analytic/slice/transmissionAnalyticSlice";
import { getFormattedDate, subtractFromDate } from "utils/date";
import { DATE_FORMAT } from "static/date";

const TransmissionAnalyticAccountFilter = () => {
  const dispatch = useDispatch();
  const { accountFilter } = useSelector((state) => state.transmissionAnalytic);

  const userRole = getCurrentUserRole();

  const { accounts } = useSelector((state) => state.account);
  const filteredAccounts = filterNonUCHAccounts(accounts);

  useEffect(() => {
    if (filteredAccounts?.length === 1 && !EVOKE_ROLES.includes(userRole)) {
      dispatch(
        changeFilter({
          type: "accountFilter",
          value: filteredAccounts?.[0]?.name,
        })
      );
    }
  }, [accounts, filteredAccounts, userRole]);

  useEffect(() => {
    dispatch(
      changeFilter({
        type: "startDate",
        value: subtractFromDate(new Date(), 1, "month").format(
          DATE_FORMAT.ISO_YYYYMMDD
        ),
      })
    );
    dispatch(
      changeFilter({
        type: "endDate",
        value: getFormattedDate(new Date()),
      })
    );
  }, []);

  return (
    accounts?.length > 0 && (
      <FormControl sx={{ minWidth: "120px", marginRight: "10px" }}>
        <Select
          disableUnderline
          value={accountFilter}
          onChange={(e) =>
            dispatch(
              changeFilter({ type: "accountFilter", value: e.target.value })
            )
          }
          disabled={filteredAccounts?.length <= 1}
          sx={{
            ".MuiSelect-standard": {
              background: "transparent",
              marginRight: "10px",
            },
            ".MuiSelect-select": {
              color: "#94BA33",
              fontSize: "0.875rem",
              fontWeight: 500,
              padding: "4px 8px",
              backgroundColor: "transparent",
            },
            "&::focus": {
              background: "transparent !important",
            },
            ".MuiSelect-icon": {
              color: "#94BA33",
            },
          }}
          variant="standard"
          IconComponent={KeyboardArrowDownIcon}
          displayEmpty
        >
          {filteredAccounts?.length > 1 && (
            <MenuItem value="">All Accounts</MenuItem>
          )}
          {filteredAccounts?.map(({ name }, index) => (
            <MenuItem key={index} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  );
};

export default TransmissionAnalyticAccountFilter;
